module.exports = __webpack_public_path__ + "static/UI pattern - navigation 2-672d5caaf3b6c87f9982d1fa372ef7d0.png";